import { listForms } from '@wix/ambassador-forms-v4-form/http';
import { toError } from '../common/error';
import { extractHttpErrorDetails, isHttpError } from './http-error';
import { ControllerError } from './errors';
import { Fieldset } from '@wix/ambassador-forms-v4-form/types';
import pRetry from 'p-retry';
export const fetchForms = async ({ formIds, formKind, namespace, httpClient, errorMonitor, throwWhenFormMissing = true, additionalMetadata, errorHandler, locale, }) => {
    const getForms = async () => {
        const headers = locale ? { 'X-Wix-Language': locale } : {};
        try {
            const { data } = await pRetry(() => errorHandler.withErrorHandler(() => httpClient.request((args) => ({
                ...listForms({
                    formIds,
                    namespace,
                    kind: formKind,
                    fieldsets: [Fieldset.NESTED_FORMS],
                    additionalMetadata,
                })(args),
                headers,
            })), { errorCodesMap: {} }), {
                retries: 3,
                onFailedAttempt: (error) => {
                    errorHandler.reportRetryAttempt(error);
                },
            });
            return data.forms ?? [];
        }
        catch (error) {
            if (isHttpError(error)) {
                const httpError = extractHttpErrorDetails(error);
                errorMonitor.captureException(new Error(`Could not fetch forms`), {
                    contexts: {
                        ...(httpError && { httpError }),
                    },
                });
            }
            else {
                errorMonitor.captureException(toError(error));
            }
            errorHandler.showError(error);
            throw new ControllerError('Could not fetch forms', error);
        }
    };
    const forms = await getForms();
    const formsById = forms.reduce((result, form) => {
        if (form.id) {
            result[form.id] = form;
        }
        return result;
    }, {});
    const hasMissingForm = formIds.find((formId) => !formsById[formId]);
    if (throwWhenFormMissing && hasMissingForm) {
        const errorMessage = 'One or more forms are missing in the server response';
        errorMonitor.captureException(new Error(errorMessage));
        throw new ControllerError(errorMessage);
    }
    return formsById;
};
//# sourceMappingURL=fetch-forms.js.map